import { useToast } from "@expert/common-ui";
import { useEffect } from "react";
import { sdkEventBus } from "@/sdk";

export const useWrapupToasts = () => {
    const toast = useToast();

    useEffect(() => {
        const unsubFromWrapupEnded = sdkEventBus.on("wrapup_ended", ({ message, type }) => {
            toast[type](message);
        });

        return unsubFromWrapupEnded;
    }, [toast]);
};
